import { hasBrowserAPI } from './hasBrowserAPI';

export const saveToLocalStorage = (key: string, value: any): void => {
  if (hasBrowserAPI()) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(error);
    }
  }
};

export const getFromLocalStorage = (key: string): any => {
  if (hasBrowserAPI()) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  return undefined;
};

export const removeFromLocalStorage = (key: string): void => {
  if (hasBrowserAPI()) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  }
};
